import {remCalc} from '_themeUtils'

const select = {
    Select: {
        baseStyle: ({menuPlacement}) => ({
            container: {
                p: 0,
                h: 'size.input.height',
                mb: 'spacing.6',
            },
            control: {
                display: 'flex',
                border: '1px solid',
                h: '100%',
                minH: 'auto',
                p: 0,
                outline: '2px solid transparent',
                outlineOffset: remCalc(2),
                borderColor: 'color.border.input.primary',
                borderRadius: 'borderRadius.input.base',
                cursor: 'pointer',
                _hover: {
                    borderColor: 'color.border.input.primary',
                    borderRadius: 'borderRadius.input.base',
                },
                _focusWithin: {
                    outlineOffset: '3px',
                    borderColor: '#1e90ff',
                    outlineColor: '#1e90ff',
                    outlineStyle: 'auto',
                    outlineWidth: '4px',
                    boxShadow: 'none',
                    input: {
                        _focus: {
                            outline: 'none',
                        },
                    },
                },
                _invalid: {
                    borderColor: 'color.border.input.error',
                    boxShadow: 'none',
                    _hover: {
                        borderColor: 'color.border.input.error',
                        boxShadow: 'none',
                    },
                    _focusVisible: {
                        borderColor: 'color.border.input.error',
                        boxShadow: 'none',
                    },
                },
                'div:first-of-type': {
                    p: 0,
                    px: 'spacing.3',
                    '>div': {
                        fontWeight: 400,
                        p: 0,
                        m: 0,
                    },
                    '>input': {
                        pos: 'absolute',
                    },
                },
            },
            menu: {
                p: 0,
                m: 0,
            },
            menuList: {
                p: 0,
                borderRadius: 'borderRadius.input.base',
                borderColor: 'color.border.input.primary',
                borderTop: menuPlacement !== 'top' && 'none',
                maxH: remCalc(192),
            },
            indicatorSeparator: {},
            dropdownIndicator: {
                position: 'relative',
                _after: {
                    content: '""',
                    position: 'absolute',
                    margin: 0,
                    padding: 0,
                    color: 'color.text.black',
                    borderTop: '.3em solid',
                    borderRight: '.3em solid transparent',
                    borderBottom: 0,
                    borderLeft: '.3em solid transparent',
                },
            },
            downChevron: {
                path: {
                    opacity: 0,
                },
            },
            option: {
                fontSize: remCalc(14),
                letterSpacing: '0.05em',
                fontWeight: 'normal',
                p: 'spacing.3',
                color: 'color.text.option.base',
                bg: 'color.background.option.base',
                transition: 'all .15s ease-in',
                zIndex: 'dropdown',
                _selected: {
                    color: 'color.text.option.negative',
                    bg: 'color.background.option.active',
                    _hover: {
                        bg: 'color.background.option.active',
                    },
                    _focus: {
                        bg: 'color.background.option.active',
                    },
                },
                _hover: {
                    bg: 'color.background.option.hover',
                },
                _focus: {
                    bg: 'color.background.option.hover',
                },
                _focusVisible: {
                    outlineColor: 'transparent',
                    boxShadow: 'none',
                },
                _focusWithin: {
                    outlineColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            singleValue: {
                color: 'color.text.input.base',
                padding: 0,
            },
            placeholder: {
                color: 'color.text.input.placeholder',
            },
            label: {
                textStyle: 'paragraphSm',
                fontWeight: 400,
                color: 'color.text.black',
                letterSpacing: remCalc(1),
                // Per Figma 58195-11032 the field label is indented inward from the input box
                // edge on every breakpoint (mobile included), so it stays offset while the box
                // aligns with the title/intro copy. Keep a fixed indent matching the text-input
                // label (form.ts).
                pl: 'spacing.3',
                pb: 'spacing.1',
                m: 0,
            },
            input: {
                mb: '0 !important',
            },
        }),
    },
    SortBySelect: {
        baseStyle: () => ({
            formControl: {
                p: 0,
            },
            container: {
                h: remCalc(33),
            },
            control: {
                display: 'flex',
                h: '100%',
                minH: 'auto',
                border: 'none',
                py: 'spacing.1.5',
                px: 'spacing.3',
                textStyle: 'paragraphSm',
                letterSpacing: remCalc(3),
                outline: '2px solid transparent',
                outlineOffset: remCalc(2),
                zIndex: 'docked',
                cursor: 'pointer',
                _focusWithin: {
                    outlineOffset: '3px',
                    borderColor: '#1e90ff',
                    outlineColor: '#1e90ff',
                    outlineStyle: 'auto',
                    outlineWidth: '4px',
                    boxShadow: 'none',
                    input: {
                        _focus: {
                            outline: 'none',
                        },
                    },
                },
                '>div': {
                    p: 0,
                    '>div': {
                        fontWeight: 400,
                        p: 0,
                        m: 0,
                        right: 0,
                        input: {
                            p: 0,
                            m: 0,
                        },
                    },
                    '>input': {
                        pos: 'absolute',
                    },
                },
            },
            menu: {
                padding: 0,
                margin: 0,
            },
            menuList: {
                w: 'fit-content',
                padding: `${remCalc(8)} 0`,
                borderRadius: 'borderRadius.input.base',
                borderColor: 'color.border.input.none',
                boxShadow: 'none',
                borderTop: 'none',
                mt: 'spacing.1',
                '>div': {
                    textStyle: 'paragraphXxs',
                    textTransform: 'uppercase',
                    letterSpacing: remCalc(2.5),
                    whiteSpace: 'nowrap',
                    py: 'spacing.3',
                    px: 'spacing.4',
                },
            },
            placeholder: {
                textStyle: 'paragraphSm',
                color: 'color.text.input.placeholder',
                letterSpacing: remCalc(3),
            },
            singleValue: {
                textStyle: 'paragraphSm',
                color: 'color.text.input.placeholder',
                letterSpacing: remCalc(3),
            },
            option: {
                color: 'color.text.option.base',
                bg: 'color.background.option.base',
                transition: 'all .15s ease-in',
                _selected: {
                    color: 'color.text.option.negative',
                    bg: 'color.background.option.active',
                    _hover: {
                        bg: 'color.background.option.active',
                    },
                    _focus: {
                        bg: 'color.background.option.active',
                    },
                },
                _hover: {
                    bg: 'color.background.option.hover',
                },
                _focus: {
                    bg: 'color.background.option.hover',
                },
                _focusVisible: {
                    outlineColor: 'transparent',
                    boxShadow: 'none',
                },
                _focusWithin: {
                    outlineColor: 'transparent',
                    boxShadow: 'none',
                },
            },
            dropdownIndicator: {
                position: 'relative',
                width: remCalc(24),
                height: remCalc(16),
                svg: {
                    display: 'none',
                },
                _after: {
                    content: '""',
                    margin: 0,
                    mt: remCalc(-1),
                    padding: 0,
                    color: 'color.text.grey.600',
                    borderTop: '.2em solid',
                    borderRight: '.2em solid transparent',
                    borderBottom: 0,
                    borderLeft: '.2em solid transparent',
                },
            },
        }),
    },
}

export default select
